import { createContext, Dispatch, SetStateAction } from 'react';

export enum SignUpSteps {
  BASIC_INFO,
  INTERESTS,
  CREATE_PASSWORD,
  FINISH,
}
export interface ISignUpContextProps {
  setSignUpProps: Dispatch<SetStateAction<Partial<ISignupStepsProps>>>;
  signUpProps: Partial<ISignupStepsProps>;
  currentStep: SignUpSteps;
  setCurrentStep: Dispatch<SetStateAction<SignUpSteps>>;
}
export interface ISignupStepsProps {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  confirmPassword: string;
  interests: Array<string>;
}
export const SignUpContext = createContext<ISignUpContextProps>({
  setSignUpProps: () => {},
  signUpProps: {
    interests: [],
  },
  currentStep: SignUpSteps.BASIC_INFO,
  setCurrentStep: () => {},
});
